module.exports = __webpack_public_path__ + "static/media/licenta23.eb7ab1da.png";